const ITEMS = [
  "DREAM BEYOND REALITY",
  "THE RISE OF BHARGAV-RAM",
  "MACHU — THE FINDING FRIEND",
  "SAHADEV — GOD OF TIME AND DESTINY",
  "WHO IS THE SNIPER?",
  "GARUTMAN",
  "COSMIC DREAMS UNIVERSE",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`whitespace-nowrap px-8 font-serif text-4xl md:text-6xl tracking-wide ${
            i % 2 === 0 ? "text-white/10" : "text-hollow"
          }`}
        >
          {t}
        </span>
        <span className="text-lg text-[#D4AF37]/40">✦</span>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative z-10 overflow-hidden border-y border-white/5 py-8 md:py-10"
    aria-hidden="true"
  >
    <div className="cd-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
